import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { HelpScoutBeaconsService } from './help-scout-beacons.service';
import { State } from './reducers';
import { PartnerThemeService } from './shared/Services/partner-theme/partner-theme.service';
import { SpinnerComponent } from './shared/Components/spinner/spinner.component';
import { sharedFeature } from './shared/ngrx/shared.state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [SpinnerComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private router = inject(Router);
  private store = inject<Store<State>>(Store);
  private partnerThemeService = inject(PartnerThemeService);
  protected helpBeacons = inject(HelpScoutBeaconsService); // do not remove

  readonly navigating = computed(() => !!this.router.currentNavigation());

  private partner = toSignal(this.store.select(sharedFeature.selectPartner));

  constructor() {
    effect(() => {
      const partner = this.partner();
      if (partner !== undefined) {
        this.partnerThemeService.applyPartner(partner);
      }
    });
  }
}
